module.exports = __webpack_public_path__ + "static/14.1-310affc1fd89efd263eac03f77f21820.jpg";